var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
		$('.icon.svg').each(function() {
			let icon = $(this).data('icon');
			if (icon && icon.length) {
				let style = "url('/static/files/icons/" + icon + ".svg') no-repeat";
				$(this).attr('style', "background: " + style);
			}
		});
	}
};


site.frontpage = {
	init: function() {

		site.frontpage.dropdown();
		site.frontpage.newsCarousel();
		site.frontpage.calendarCarousel();
		$(window).resize(function() {
			site.frontpage.newsCarousel();
			site.frontpage.calendarCarousel();
		});

		site.owl.init('#banner_wrapper ul', {
			nav: false,
			loop: true,
			dots: false,
			autoplay: true,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			items: 1,
			lazyLoad: true,
			autoplayTimeout: 15001,
		})

		site.owl.init('.service .items', {
			nav: true,
			loop: false,
			dots: false,
			margin: 30,
			navText: ["<div class=\"left\"><i class=\"fas fa-long-arrow-alt-left\"></i></div>", "<div class=\"right\"><i class=\"fas fa-long-arrow-alt-right\"></i></div>"],
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 2
				},
				992: {
					items: 4
				}
			},
			onInitialized: function (event) {
				$('.box_extras_category .service .owl-item').attr('aria-selected','false');
				$('.box_extras_category .service .owl-item.active').attr('aria-selected','true');
				$('.box_extras_category .service .owl-prev').attr('role','button').attr('aria-label','Fyrri');
				$('.box_extras_category .service .owl-next').attr('role','button').attr('aria-label','Næsti');
			},
			onChanged : function() {
				setTimeout(
					function()
					{
						$('.box_extras_category .service').find('.owl-item:not(.active)').attr('aria-selected','false');
						$('.box_extras_category .service').find('.owl-item.active').attr('aria-selected','true');
						$('.box_extras_category .service').find('.owl-item:not(.active) a').attr('tabindex',-1);
						$('.box_extras_category .service').find('.owl-item.active a').attr('tabindex',0);
					}, 50);
			}
		});
	},


	hasNewsCarousel: false,
	hasCalendarCarousel: false,

	initResponsiveCarousel: function({ hasCarouselFlag, setCarouselFlag, containerSelector, initSelector, destroySelector}) {
		const $body = $('body');

		if ($body.width() < 768) {
			if (!site.frontpage[hasCarouselFlag]) {
				site.owl.init(initSelector, {
					nav: true,
					loop: false,
					dots: false,
					margin: 30,
					center: true,
					navText: ["<div class=\"left\"><i class=\"fas fa-long-arrow-alt-left\"></i></div>", "<div class=\"right\"><i class=\"fas fa-long-arrow-alt-right\"></i></div>"],
					responsive: {
						0: {
							items: 1
						},
						425: {
							items: 2
						}
					},
					onInitialized: function () {
						$(`${containerSelector} .owl-item`).attr('aria-selected','false');
						$(`${containerSelector} .owl-item.active`).attr('aria-selected','true');
						$(`${containerSelector} .owl-prev`).attr('role','button').attr('aria-label','Fyrri');
						$(`${containerSelector} .owl-next`).attr('role','button').attr('aria-label','Næsti');
					},
					onChanged: function () {
						setTimeout(() => {
							$(`${containerSelector} .owl-item:not(.active)`).attr('aria-selected','false');
							$(`${containerSelector} .owl-item.active`).attr('aria-selected','true');
							$(`${containerSelector} .owl-item:not(.active) a`).attr('tabindex',-1);
							$(`${containerSelector} .owl-item.active a`).attr('tabindex',0);
						}, 50);
					}
				});
				site.frontpage[setCarouselFlag] = true;
			}
		} else {
			if (site.frontpage[hasCarouselFlag]) {
				$(destroySelector).owlCarousel('destroy').removeClass('owl-carousel');
				site.frontpage[setCarouselFlag] = false;
			}
		}
	},

	newsCarousel: function() {
		site.frontpage.initResponsiveCarousel({
			hasCarouselFlag: 'hasNewsCarousel',
			setCarouselFlag: 'hasNewsCarousel',
			containerSelector: 'main .box_newsheadlines .news__entries',
			initSelector: 'main .box_newsheadlines .news__entries',
			destroySelector: '.box_newsheadlines .items'
		});
	},

	calendarCarousel: function() {
		site.frontpage.initResponsiveCarousel({
			hasCarouselFlag: 'hasCalendarCarousel',
			setCarouselFlag: 'hasCalendarCarousel',
			containerSelector: '.box_calendar_eventlist .boxes',
			initSelector: 'main .box_calendar_eventlist .boxes',
			destroySelector: '.box_calendar_eventlist .event__single'
		});
	},
	dropdown: function () {
		$('h2', 'header .shortcuts').wrapInner('<a href="#">');

		site.toggle.init('header .shortcuts h2 a', '.box.shortcuts', 'shortcuts');
		site.maxHeight.init('.shortcuts ul');
	},
};

site.translate = {
	currentLang: null,
	callback: function () {
		site.translate.currentLang = $('html').attr('lang');
		$('#google_translate_element').bind('DOMSubtreeModified', function() {
			setTimeout(() => {
				const lang = $('html').attr('lang');
				if (site.translate.currentLang !== lang) {
					site.translate.currentLang = lang;
					$('.accordion.ready .wrap').removeAttr('style');
				}
			}, 100);
		});
	}
};

site.navigation = {
	init: function () {
		var $body = $('body');
		$('.level1 > a', '#mainmenu').on('click', function(e) {
			if ($body.width() < 991) {
				e.preventDefault();
				var $this = $(this);
				var className = $this.closest('li').attr('class').split(' ')[0];
				$('.' + className + ' > a', '#mMenu').trigger('click');
				$('#mainmenuToggle').trigger('click');
			}
		});
	}
}


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.mMenu.init();
	site.megamenu.init();
	site.meetingBoxes.init();
	site.labelFocus.init();
	site.translate.callback();
	site.navigation.init();

	$('a.goog-te-menu-value').attr('aria-label', 'Þýðingartól');

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	$('.shareThis').click(function(e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'shareWindow', width, height);
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);

	// Open jobs popup window when using anchor in url
	if (document.location.hash) {
		$('#jobs a[href='+document.location.hash+']').parents('.accordion').addClass('open');
		setTimeout(() => {
			$('a[href='+document.location.hash+']', '#jobs').trigger('click');
		}, 500)


	}
});


function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}
